import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const CosmetologistVsLuvly = lazyWithPreload(
  () => import('./CosmetologistVsLuvly'),
)
